module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"button.create_drone":"เพิ่ม Drone ใหม่","drone.search.keyword.placeholder":"ค้นหาจาก Drone S/N"}}')
  delete Component.options._Ctor
}
